(function () {
  function initAdviceSearch() {
    var input = document.querySelector('[data-advice-search]');
    var cards = document.querySelectorAll('[data-advice-card]');
    var emptyState = document.querySelector('[data-advice-empty]');

    if (!input || !cards.length) {
      return;
    }

    input.addEventListener('input', function () {
      var query = input.value.toLowerCase().trim();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var searchText = card.getAttribute('data-search') || '';
        var matches = !query || searchText.indexOf(query) !== -1;

        card.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }
      });

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAdviceSearch);
  document.addEventListener('shopify:section:load', initAdviceSearch);
})();